import { api } from "./apiClient";

export const usersAPI = {
    getCurrent: () => api.get("/users/me"),
    list: () => api.get("/users"), // admin-only
    create: (payload) => api.post("/users", payload),
    update: (userId, payload) => api.patch(`/users/${userId}`, payload),
    updateSystemRole: (userId, payload) =>
        api.patch(`/users/${userId}/role`, payload),
    deactivate: (userId) => api.delete(`/users/${userId}`),
};
